import { AppRouter } from '@gongsegae/api';
import { useQuery } from '@tanstack/react-query';
import { TRPCClientError } from '@trpc/client';
import { format } from 'date-fns';
import { useMemo } from 'react';

import { trpc } from '@/lib/trpc';

export function isTRPCClientError(error: unknown): error is TRPCClientError<AppRouter> {
  return error instanceof TRPCClientError;
}

interface UseIsSoldOutReturn {
  isSoldOut: (menuId: number) => boolean;
  isLoading: boolean;
  error: unknown;
  refresh: () => void;
}

export function useIsSoldOut(date: Date | null): UseIsSoldOutReturn {
  const dateStr = date ? format(date, 'yyyy-MM-dd') : null;

  // TanStack Query로 해당 날짜의 품절 정보 조회
  const {
    data: menuStatusList,
    error,
    isLoading,
    refetch,
  } = useQuery(
    trpc.schedule.dailyMenuStatusByDate.queryOptions(
      {
        date: dateStr ?? '',
      },
      {
        enabled: !!dateStr,
      }
    )
  );

  // 품절된 메뉴 ID들의 Set 생성
  const soldOutMenuIds = useMemo(() => {
    if (!menuStatusList) return new Set<number>();

    const soldOutIds = new Set<number>();
    menuStatusList.forEach((status: any) => {
      if (status.isSoldOut) {
        soldOutIds.add(status.menuId);
      }
    });

    return soldOutIds;
  }, [menuStatusList]);

  // 특정 메뉴가 품절인지 확인하는 함수
  const isSoldOut = (menuId: number): boolean => {
    return soldOutMenuIds.has(menuId);
  };

  return {
    isSoldOut,
    isLoading,
    error,
    refresh: () => refetch(),
  };
}
